module.exports = __webpack_public_path__ + "img/top02.1df337e7.gif";